export default {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },

  '&singleLine': {
    display: 'inline-block',
    width: '100%',

    highlighter: {
    },
    input: {
      outline: 'none',
      width: '100%'
    },
  },

  suggestions: {
    left: '0',
    top: '100%',
    bottom: 'unset',
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      overflow: "auto",
      maxHeight: 250,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#F4FCF8',
        color: window?.settings?.primary_color ?? '#1DBD6B'
      },
    },
  },
}
